<h1 mat-dialog-title class="se-dialog-header mat-elevation-z6">
    {{ 'SelectBurnDevice' | translate }}
</h1>

<div mat-dialog-content class='se-burn-device-dialog-content'>

    <mat-form-field appearance="outline">
        <mat-label>{{ 'Burners' | translate }}</mat-label>
        <mat-select [formControl]="selectedDeviceControl" [placeholder]="'Burners' | translate">
            <mat-option *ngFor="let device of data.devicesList" [value]="device">
                {{ device.description }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-checkbox class="se-burn-device-checkbox" [checked]="_defaultChecked" (change)="_onDefaultCheckedChange()">
        {{ 'DefaultBurnerChecked' | translate }}
    </mat-checkbox>

</div>

<mat-dialog-actions class="se-dialog-action-container">
    <button mat-button
            mat-dialog-close
            class="se-dialog-action-button"
            type="button">
        {{ 'Cancel' | translate }}
    </button>

    <button mat-button
            (click)="_onConfirm()"
            class="se-dialog-action-button"
            type="button"
            color="primary"
            [disabled]="selectedDeviceControl.invalid || !selectedDeviceControl.value"
            [mat-dialog-close]="_setDialogOutputValues()">
        {{ 'BurnCreateConfirm' | translate }}
    </button>
</mat-dialog-actions>


